import {
  GET_SCALPCAMERA_PIN_CODE,
  GET_SCALPCAMERA_DIAGNOSIS_RESULT,
  SET_SCALPCAMERA_PIN_CODE,
  RESET_SCALPCAMERA_PIN_CODE,
  RESET_SCALPCAMERA_DIAGNOSIS,
  UPDATE_SCALP_CAMERA_STATUS,
} from '../constants';
import { getScalpCameraPinCode, getScalpCameraResults } from '../../services/api';

export const getPinCode = type => ({
  type: GET_SCALPCAMERA_PIN_CODE,
  payload: getScalpCameraPinCode(type),
});
export const resetScalpCameraDiagnosis = () => ({
  type: RESET_SCALPCAMERA_DIAGNOSIS,
});
export const getScalpCameraDiagnosisResults = pin => ({
  type: GET_SCALPCAMERA_DIAGNOSIS_RESULT,
  payload: getScalpCameraResults(pin),
});
export const setScalpCameraPinCode = pinCode => ({
  type: SET_SCALPCAMERA_PIN_CODE,
  payload: pinCode,
});
export const resetScalpCameraPinCode = pinCode => ({
  type: RESET_SCALPCAMERA_PIN_CODE,
  payload: pinCode,
});

/**
 * スカルプカメラアプリ起動状況を更新する (起動成功/失敗)
 */
export const updateScalpCameraStatus = parameters => ({
  type: UPDATE_SCALP_CAMERA_STATUS,
  payload: parameters,
});

// export default getPinCode;



// WEBPACK FOOTER //
// ./src/redux/actions/scalpCameraDiagnosis.js